function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVipps = function SvgVipps(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36.23 25.06",
    style: {
      enableBackground: "new 0 0 36.23 25.06"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a9c2d1"
    },
    d: "M33.23 1c1.103 0 2 .897 2 2v19.06c0 1.103-.897 2-2 2H3c-1.103 0-2-.897-2-2V3c0-1.103.897-2 2-2h30.23m0-1H3a3 3 0 0 0-3 3v19.06a3 3 0 0 0 3 3h30.23a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff5b24"
    },
    d: "m6.938 10.232 1.06 3.099 1.04-3.099h1.227l-1.83 4.596H7.52l-1.83-4.596h1.248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "m30.52 13.58 3.098-1.06-3.099-1.04v-1.248l4.596 1.83v.915l-4.596 1.83V13.58zM6.938 14.807l1.06 3.099 1.04-3.099h1.227l-1.83 4.596H7.52l-1.83-4.596h1.248zM9.038 10.253l-1.06-3.099-1.04 3.099H5.69l1.85-4.596h.916l1.83 4.596H9.038z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "m5.71 11.48-3.098 1.06 3.099 1.061v1.227l-4.596-1.83v-.915l4.596-1.85v1.247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff5b24"
    },
    d: "M13.03 14.1c.77 0 1.207-.374 1.623-.915.228-.291.52-.353.727-.187.208.166.23.478 0 .77-.603.79-1.372 1.268-2.35 1.268-1.06 0-1.996-.582-2.64-1.601-.188-.27-.146-.562.062-.707.208-.146.52-.084.707.208.458.686 1.081 1.164 1.872 1.164zm1.435-2.558a.612.612 0 0 1-.623.624c-.333 0-.624-.25-.624-.624s.29-.624.624-.624.623.27.623.624zM17.398 10.232v.624c.312-.437.79-.749 1.497-.749.894 0 1.934.749 1.934 2.35 0 1.685-.998 2.496-2.038 2.496-.54 0-1.04-.208-1.414-.728v2.204h-1.123v-6.197h1.144zm0 2.288c0 .935.54 1.434 1.143 1.434.583 0 1.165-.457 1.165-1.434 0-.957-.582-1.414-1.165-1.414-.582 0-1.143.436-1.143 1.414zM22.804 10.232v.624c.312-.437.79-.749 1.498-.749.894 0 1.934.749 1.934 2.35 0 1.685-.999 2.496-2.038 2.496-.541 0-1.04-.208-1.414-.728v2.204H21.66v-6.197h1.143zm0 2.288c0 .935.541 1.434 1.144 1.434.582 0 1.165-.457 1.165-1.434 0-.957-.583-1.414-1.165-1.414-.603 0-1.144.436-1.144 1.414zM28.627 10.107c.936 0 1.601.437 1.892 1.518l-1.019.167c-.02-.54-.353-.728-.852-.728-.375 0-.666.166-.666.437 0 .208.146.416.583.499l.769.145c.749.146 1.165.645 1.165 1.31 0 .999-.895 1.498-1.747 1.498-.894 0-1.893-.458-2.038-1.58l1.019-.167c.062.582.416.79.998.79.437 0 .728-.166.728-.437 0-.25-.146-.436-.624-.52l-.707-.124c-.749-.146-1.206-.666-1.206-1.331.02-1.04.956-1.477 1.705-1.477z"
  }));
};
export { SvgVipps as ReactComponent };
export default __webpack_public_path__ + "c59aafe9.svg";